// billsLayoutSlice.ts
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { Country, Utility } from '../../model/bill-settings/bill-settings';


interface BillsLayoutState {
  isCountrySelectorVisible: boolean;
  selectedCountry: Country | null;
  selectedUtility: Utility | null;
  isExportButtonVisible: boolean;
  isBreadCrumbVisible: boolean;
  pageTitleVersion: number;
  isBroadcastButtonVisible: boolean;
}

const initialState: BillsLayoutState = {
  isCountrySelectorVisible: false,
  selectedCountry: null,
  selectedUtility: null,
  isExportButtonVisible: false,
  isBreadCrumbVisible: false,
  pageTitleVersion: 0,
  isBroadcastButtonVisible: false,
};

const billsLayoutSlice = createSlice({
  name: 'billsLayout',
  initialState,
  reducers: {
    setCountrySelectorVisibility: (state, action: PayloadAction<boolean>) => {
      state.isCountrySelectorVisible = action.payload;
    },
    setSelectedCountry: (state, action: PayloadAction<Country | null>) => {
      state.selectedCountry = action.payload;
    },
    setSelectedUtility: (state, action: PayloadAction<Utility | null>) => {
      state.selectedUtility = action.payload;
    },
    setExportButtonVisibility: (state, action: PayloadAction<boolean>) => {
      state.isExportButtonVisible = action.payload;
    },
    setBreadCrumbButtonVisibility: (state, action: PayloadAction<boolean>) => {
        state.isBreadCrumbVisible = action.payload;
    },
    bumpPageTitleVersion: (state) => {
        state.pageTitleVersion += 1;
    },
    setBroadcastButtonVisibility: (state, action: PayloadAction<boolean>) => {
        state.isBroadcastButtonVisible = action.payload;
    },
  },
});

export const {
  setCountrySelectorVisibility,
  setSelectedCountry,
  setSelectedUtility,
  setExportButtonVisibility,
  setBreadCrumbButtonVisibility,
  bumpPageTitleVersion,
  setBroadcastButtonVisibility,
} = billsLayoutSlice.actions;

export default billsLayoutSlice.reducer;